// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atf-and-default-123-2.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atf-and-default-123-2/atf-and-default-123-2.js';
import g1 from '../lessons/air-law/atf-and-default-123-2/atf-runway-confirmation.js';
import g2 from '../lessons/air-law/atf-and-default-123-2/unicom-and-unicom-au.js';

mount([g0, g1, g2]);
